<template>
     <v-layout row wrap class="home">
        <v-flex >
            <v-carousel interval="7000" :height="window.height - 48" hide-controls hide-delimiters>
                <v-carousel-item :src="congresso">
                    <v-layout  class=" white--text" align-center wrap row>
                    <v-flex xs12 class="spacer-home"></v-flex>
                    <v-flex xs7 offset-xs1 class="jumbo-text">
                        <h1><strong>Direito Constitucional, Administrativo e Político-Eleitoral</strong></h1>
                        <v-btn color="secondary text-none" @click="$vuetify.goTo('#contato', {option})"> <strong>Entre em contato</strong> </v-btn>
                    </v-flex>
                </v-layout>
                </v-carousel-item>

                <v-carousel-item :src="civil">
                    <v-layout  class=" white--text" align-center wrap row>
                    <v-flex xs12 class="spacer-home"></v-flex>
                    <v-flex xs7 offset-xs1 class="jumbo-text">
                        <h1><strong>Consultoria especializada em Direito Civil, Família e Sucessões</strong></h1>
                        <v-btn color="secondary text-none" @click="$vuetify.goTo('#contato', {option})"> <strong>Entre em contato</strong> </v-btn>
                    </v-flex>
                </v-layout>
                </v-carousel-item>

                <v-carousel-item :src="stf">
                    <v-layout  class=" white--text" align-center wrap row>
                    <v-flex xs12 class="spacer-home"></v-flex>
                    <v-flex xs7 offset-xs1 class="jumbo-text">
                        <h1> <strong>Soluções em Tributos e Direito Aduaneiro para sua empresa</strong></h1>
                        <v-btn color="secondary text-none" @click="$vuetify.goTo('#contato', {option})"> <strong>Entre em contato</strong> </v-btn>
                    </v-flex>
                </v-layout>
                </v-carousel-item>

            </v-carousel>
            
            <v-container class="secao" id="quemsomos">
                <Quem/>
            </v-container>

            <hr>

            <v-container id="advogados">
                <Advogados/>
            </v-container>

            <hr>

            <v-container class="secao"  id="solucoes" fluid>
                <Solucoes/>
            </v-container>

            <hr>


            <!-- <v-container class="secao"   id="publicacoes" >
                <PostsPreview></PostsPreview>
            </v-container> -->

        </v-flex>
    </v-layout>
</template>

<script>
import PostsPreview from '../components/PostsPreview' 
import Quem from './Quem'
import Solucoes from './Solucoes'
import Advogados from './Advogados'
import agro from '../assets/agronegocio.png'
import civil from '../assets/civil.png'
import congresso from '../assets/congresso.png'
import stf from '../assets/stf.png'

export default {
    components: { PostsPreview, Quem, Solucoes, Advogados},

    data (){
        return{
            congresso, stf, civil, agro,
            window: {
                width: 0,
                height: 0
            },
        }
    },

    methods: {
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        }
    },

    created(){
        window.addEventListener('resize', this.handleResize)
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    },
}
</script>

<style>
hr {
    width: 85%;
    margin-left: auto;
    margin-right: auto;
}

.spacer-home{
    height: 40vh;
}

.parallax .v-btn {
    margin-left: 0px !important;
    margin-bottom: 24px !important;
}
.secao {
    padding-top: 64px;
}
.secao{
    margin-bottom: 64px;
}
</style>
